import {
  Breadcrumbs, Link, useMediaQuery, useTheme,
} from '@mui/material';
import { ArrowRightAlt } from '@mui/icons-material';
import { memo } from 'react';

const PathBreadcrumbsVcms = ({ linkArr, lang }: any) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <Breadcrumbs
      // sx={{ p: pr`16px` }}
      aria-label="breadcrumb"
      separator={<ArrowRightAlt fontSize="small" />}
      maxItems={matches ? 5 : 1}
    >
      {(linkArr || []).map((link: any) => (
        <Link
          key={link.url}
          underline="always"
          color="inherit"
          href={link.url?.replace('.en-', '-')}
          target={link.newTab ? '_blank' : ''}
        >
          {link.text}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default memo(PathBreadcrumbsVcms);
